import script from "./LiveClipper.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveClipper.vue?vue&type=script&setup=true&lang=js"

import "./LiveClipper.vue?vue&type=style&index=0&id=e2376036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2376036"]])

export default __exports__